<template>
  <svg 
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <title
      :id="iconName"
      lang="en"
    >
      {{ iconName }} icon
    </title>
    <g     
      :font-size="textSize"
      :style="[ styleObject ]"
    >
      <slot />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box'
    },
    width: {
      type: [Number, String, Array],
      default: "w-full"
    },
    height: {
      type: [Number, String],
      default: "h-full"
    },
    viewBox: {
      type: String,
      default: '0 0 18 18'
    },
    textFont:{
      type: String,
      default: 'PotatoesAndPeasRegular, Potatoes And Peas'
    },
    textColor:{
      type: String,
      default: 'transparent'
    },
    iconBorder:{
      type: String,
      default: 'transparent'
    },
    textSize:{
      type: String,
      default: '229.4px'
    },
  },
  computed: {
    styleObject() {
        return { '--iconFontFamily': this.textFont, '--iconTextColor': this.textColor, '--iconFontSize': this.textSize, '--iconBorderColor': this.iconBorder  }
    } 
  }
}
</script>